import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSave, faTrash, faPlus, faPen } from '@fortawesome/free-solid-svg-icons';

export const IconButton = props => {
  return (
    <button
      className={props.className || 'button is-primary'}
      onClick={props.onClick}
      title={props.title}
      disabled={props.disabled || false}
    >
      <FontAwesomeIcon icon={props.icon} />
      {props.text && <span className="ml-10px">{props.text}</span>}
    </button>
  );
};

IconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.object.isRequired,
  text: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export const SaveButton = props => (
  <IconButton
    className={classnames('button is-link', props.className || '')}
    text="Save"
    icon={faSave}
    onClick={props.onClick}
    disabled={props.disabled || false}
  />
);

SaveButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export const DeleteButton = props => (
  <IconButton
    className={classnames('button is-danger', props.className || '')}
    text={props.text}
    icon={faTrash}
    onClick={props.onClick}
  />
);

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
};

export const IconLink = props => {
  return (
    <Link className={props.className || 'button is-primary'} to={props.to}>
      <FontAwesomeIcon icon={props.icon} />
      {props.text && <span className="ml-10px">{props.text}</span>}
    </Link>
  );
};

IconLink.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  text: PropTypes.string,
};

export const BackLink = props => <IconLink to={props.to} className="button is-info" text="Back" icon={faArrowLeft} />;

BackLink.propTypes = {
  to: PropTypes.string.isRequired,
};

export const AddLink = props => (
  <IconLink
    className={classnames('button is-link', props.className || '')}
    text={props.text}
    icon={faPlus}
    to={props.to}
  />
);

AddLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
};

export const EditLink = props => (
  <IconLink
    className={classnames('button is-link', props.className || '')}
    text={props.text}
    icon={faPen}
    to={props.to}
  />
);

EditLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
};
